import { isEmpty, isObject } from 'lodash';
const DEFAULT_ERROR_MESSAGE = 'Something went wrong on our side. Please try again later.';

const getErrorMessage = (responseError, field = '') => {
  if (!isObject(responseError)) {
    return DEFAULT_ERROR_MESSAGE;
  }

  if (!isEmpty(responseError?.errors) && field) {
    return responseError.errors[field] || DEFAULT_ERROR_MESSAGE;
  }

  if (!isEmpty(responseError?.errors) && responseError?.errorMessage === 'Invalid request') {
    if (Array.isArray(responseError.errors) && responseError.errors[0]?.message) {
      return responseError.errors[0].message;
    }
    const entries = Object.entries(responseError.errors);
    if (entries.length > 0 && typeof entries[0][1] === 'string') {
      return entries[0][1];
    }
  }

  return responseError?.errorMessage || responseError?.message || DEFAULT_ERROR_MESSAGE;
};
export default getErrorMessage;
